import type { ReactNode } from "react";

import { SmileSimulationLogo } from "./SmileSimulationLogo";

type ExperienceSimulationLayoutProps = {
  children: ReactNode;
  footer?: ReactNode;
  onHomeClick?: () => void;
  title?: ReactNode;
};

export function ExperienceSimulationLayout({
  children,
  footer,
  onHomeClick,
  title = (
    <>
      당신이 몰랐던, 내일의 <span className="text-[#8F14E5]">미소</span>를 만날
      시간
    </>
  ),
}: ExperienceSimulationLayoutProps) {
  const handleGoHome = () => {
    if (onHomeClick) {
      onHomeClick();
      return;
    }

    window.location.assign("/experience");
  };

  return (
    <section className="flex h-full min-h-0 w-full flex-1 flex-col items-center text-center">
      <div className="flex shrink-0 flex-col items-center pt-1 sm:pt-2">
        <button
          type="button"
          onClick={handleGoHome}
          aria-label="Experience 스마일 시뮬레이션 홈"
          className="block h-auto w-[180px] sm:w-[220px]"
        >
          <SmileSimulationLogo className="h-auto w-full" />
        </button>
        {title ? (
          <h2 className="mt-5 text-[1.4rem] font-extrabold leading-tight tracking-[-0.04em] text-black sm:mt-6 sm:text-[1.7rem]">
            {title}
          </h2>
        ) : null}
      </div>

      <div className="flex min-h-0 w-full flex-1 items-center justify-center py-5 sm:py-6">
        <div className="flex aspect-[3/4] h-[min(59svh,35rem)] max-h-full max-w-full items-center justify-center sm:h-[min(64svh,40rem)]">
          {children}
        </div>
      </div>

      {footer ? (
        <div className="w-full shrink-0 pb-1 sm:pb-2">{footer}</div>
      ) : null}
    </section>
  );
}
